import { useFlags } from 'launchdarkly-react-client-sdk';
import Config from 'config';

export const cartLoggerEnabled = () => {
  const { reactBugFender } = useFlags();
  return reactBugFender && Config.env !== 'development';
};
